/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import {useFormContext} from 'react-hook-form'
import {KTCard} from '../../../../../../../../_metronic/helpers'
import {Button, ButtonWrapper} from '../../../../../../components/UI/Button'
import {InputDateWrapper, SelectWrapper} from '../../../../../../components/UI/Form/Input'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {formatDate} from '../../../../../../util/dates'
import {useCampaments} from '../../../../hooks/central/useCampaments'
import {useProgrammingServices} from '../../../../hooks/limpieza/useProgrammingServices'
import {CleaningStatusDto} from '../../../../model/cleaningStatus.model'
import {CLEANING_STATUS_SERVICES} from '../../../../services/cleaning-status.service'
import {CleaningStatusTable} from '../table/cleaning-status'
import {ModalObservations} from '../modal/observations'
import {ModalInformation} from '../modal/information'
import {ModalObservationDetail} from '../modal/observation-detail'
// import {CensusHistoryTable} from '../table/census-history'

export const CleaningStatusForm = () => {
  const {getCampaments, campaments, clearCampaments} = useCampaments()
  const {getProgrammingServices, programmingServices, clearProgrammingServices} =
    useProgrammingServices()

  // const {pagination, setPagination, setData} = useKTable()

  const {setValue, handleSubmit, setError, watch, control} = useFormContext()

  const searching = watch('searching')
  const searchNumber = watch('searchNumber')
  // const [searching, setSearching] = useState(false)
  // const [dataTotals, setDataTotals] = useState({
  //   TotalHabitaciones: 0,
  //   TotalCompletado: 0,
  //   TotalPendiente: 0,
  //   TotalObservado: 0,
  //   TotalIncompleto: 0,
  // })

  useEffect(() => {
    if (campaments.length === 1) {
      setValue('CampamentoId', campaments[0].value)
      setError('CampamentoId', {})
      getProgrammingServices({CampamentoId: campaments[0].value, pageNumber: 1, size: 100})
    }
  }, [campaments])

  useEffect(() => {
    if (programmingServices.length === 1) {
      setValue('ServiceSchedulingId', programmingServices[0].value)
      setError('ServiceSchedulingId', {})
    }
  }, [programmingServices])

  useEffect(() => {
    getCampaments({isCombo: true}, 1)
    return () => {
      clearCampaments()
      clearProgrammingServices()
    }
  }, [])

  const handleClear = () => {
    setValue('CampamentoId', '')
    setValue('ServiceSchedulingId', '')
    setValue('FechaIni', formatDate(new Date()))
    setValue('FechaFin', formatDate(new Date()))
    // setData([])
    // setDataTotals({
    //   TotalHabitaciones: 0,
    //   TotalCompletado: 0,
    //   TotalPendiente: 0,
    //   TotalObservado: 0,
    //   TotalIncompleto: 0,
    // })
  }

  const onSubmit = async (dataForm: CleaningStatusDto) => {
    const fechaIni = new Date(dataForm.FechaIni)
    const fechaFin = new Date(dataForm.FechaFin)
    const diferenciaDias = Math.floor(
      (fechaFin.getTime() - fechaIni.getTime()) / (1000 * 60 * 60 * 24),
    )

    if (fechaFin < fechaIni) {
      setError('FechaFin', {
        type: 'manual',
        message: 'La fecha fin no puede ser menor a la fecha de inicio',
      })
      return
    }

    if (diferenciaDias > 31) {
      setError('FechaFin', {
        type: 'manual',
        message: 'El rango de fechas no puede ser mayor a 31 días',
      })
      return
    }
    setValue('searchNumber', searchNumber + 1)
  }

  const handleCampamentChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('CampamentoId', value)
    setError('CampamentoId', {})
    getProgrammingServices({CampamentoId: value, pageNumber: 1, size: 100})
  }

  return (
    <KTCard shadow className='m-5'>
      <div className='p-6'>
        <form className='m-2'>
          <div className='d-flex row'>
            <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
              <SelectWrapper
                labelText='Campamento'
                name='CampamentoId'
                data={campaments}
                onChangeValue={handleCampamentChange}
                required
              />
            </div>
            <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
              <SelectWrapper
                labelText='Servicio Programado'
                name='ServiceSchedulingId'
                data={programmingServices}
                required
              />
            </div>
            <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
              <InputDateWrapper labelText='Fecha Inicio' name='FechaIni' required />
            </div>
            <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
              <InputDateWrapper labelText='Fecha Fin' name='FechaFin' required />
            </div>
          </div>
          <ButtonWrapper className={'sdx-white-bg'}>
            <Button
              label='Buscar'
              onClick={handleSubmit(onSubmit)}
              loading={searching}
              disabled={searching}
            />
            <Button label='Limpiar' onClick={handleClear} />
          </ButtonWrapper>
        </form>
      </div>
    </KTCard>
  )
}

export const CleaningStatusWrapper = () => {
  const {watch} = useFormContext()
  const showModalProgrammingService = watch('showModalProgrammingService')
  const showModalProgrammingServiceDetails = watch('showModalProgrammingServiceDetails')
  const showModalObservationDetails = watch('showModalObservationDetails')
  return (
    <>
      <CleaningStatusForm />
      <KTableProvider key='table'>
        <CleaningStatusTable />
      </KTableProvider>
      <KTableProvider key='modal'>
        {showModalProgrammingService && <ModalObservations />}
      </KTableProvider>
      {showModalProgrammingServiceDetails && <ModalInformation />}
      {showModalObservationDetails && <ModalObservationDetail />}
    </>
  )
}
